const ID_TOKEN_KEY = "id_token";
const ID_REFRESHTOKEN_KEY = "id_refresh_token";

/**
 * @description get token from localStorage
 */
export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const getRefreshToken = () => {
  return window.localStorage.getItem(ID_REFRESHTOKEN_KEY);
};

/**
 * @description save token into localStorage
 * @param {string} token
 */
export const saveToken = (token) => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};
export const saveRefreshToken = (token) => {
  window.localStorage.setItem(ID_REFRESHTOKEN_KEY, token);
};

/**
 * @description remove token from localStorage
 */
export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};
export const destroyRefreshToken = () => {
  window.localStorage.removeItem(ID_REFRESHTOKEN_KEY);
};

export default {
  getToken,
  getRefreshToken,
  saveToken,
  saveRefreshToken,
  destroyToken,
  destroyRefreshToken,
};
